import Monke from "../../img/2025/Huso.jpeg";
const Puzzle1 = () => {
  return (
    <main style={{ padding: 24 }}>
      <h1>🚽 7. Huso der HS – Das verwirrende Rätsel</h1>

      <p>
        Hehehe… Huso hier. Der Schlaue. Der Freche. Der Verdrehte! Meine Rätsel
        sind wie ich: nicht ganz sauber – aber verdammt clever. Dreh dich
        dreimal im Kreis, und dann versuch’s!
      </p>
      <img src={Monke} style={{ maxWidth: "100%", marginBottom: "32px" }} />
      <p>
        <b style={{ fontSize: "1.2em" }}>
          Du bist wie mein ganzer Name. Ein Hurensohn. Hahah. Die Lösung ist 3.
          Oder doch 6? Wie viele Affen sind wir nochmal in der Affenbande? Hugo
          musst du nicht mitzählen.
        </b>
      </p>
    </main>
  );
};

export default Puzzle1;
